<h2 mat-dialog-title translate>Legend</h2>
<mat-dialog-content>
    <div>
        <mat-table #curriculumTable [dataSource]="curriculumMarkTypes">
            <ng-container matColumnDef="Mark">
                <mat-header-cell *matHeaderCellDef><span translate>Mark</span></mat-header-cell>
                <mat-cell *matCellDef="let ele">{{ele.Code}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="Description">
                <mat-header-cell *matHeaderCellDef style="width: 250px;"><span translate>Description</span></mat-header-cell>
                <mat-cell *matCellDef="let ele">{{ele.Description}}</mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="ColumnsToDisplay"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ColumnsToDisplay;" matRipple class="element-row">
            </mat-row>
        </mat-table>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-right'>
        <tyl-button style="float:right;" image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>
